import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import PageHero from "@/components/PageHero";

const FAQ_GROUPS = [
  { group: "REGISTRATION & PARTICIPATION", items: [
    { q: "How can I register for a SPORTIVE event?", a: "Select an upcoming event from the Events page and click Register Now. Fill in the registration form and you will receive a confirmation with your unique registration ID (SPR-XXXXXX) by email." },
    { q: "Are SPORTIVE events only for professional runners?", a: "No. Events include categories for experienced runners, amateur runners, beginners and recreational participants depending on the event. Many events include 5K and 2K fun-run categories." },
    { q: "Can I participate from another city?", a: "Yes. Many RUNSAFARI events are designed specifically to attract participants from outside the destination — travel and stay guidance is shared with registered participants." },
    { q: "How do I find my registration details?", a: "Use the My Registration tab on the Results page and search with your email or registration ID." },
    { q: "What do participants receive?", a: "Depending on the event: finisher medal, event T-shirt, race bib, timed or non-timed bib options, hydration support, refreshments, goody bag, e-certificate, and trophies for top performers. Destination events may additionally include safaris, local tours and cultural experiences." },
  ]},
  { group: "RUNSAFARI & EVENTS", items: [
    { q: "What is RUNSAFARI?", a: "RUNSAFARI is SPORTIVE's destination-running concept combining running, travel, exploration, culture and local experiences — you experience the destination through the run." },
    { q: "Does SPORTIVE organise marathon events?", a: "Yes. SPORTIVE conceptualises and manages marathon, half marathon, 10K, 5K, trail and destination-based running experiences across India." },
    { q: "Where can I find my results and certificate?", a: "Visit the Results page to search official results by event, name, bib number or category, and download your finisher certificate from the Certificates tab." },
    { q: "Are event dates ever changed?", a: "Occasionally, due to weather, administrative or safety considerations. Any change is communicated to registered participants by email and updated on the event page." },
  ]},
  { group: "PARTNERSHIPS", items: [
    { q: "Can a tourism department partner with SPORTIVE?", a: "Yes. SPORTIVE develops destination-based sporting and sports tourism projects in collaboration with tourism departments, government organisations and district administrations." },
    { q: "How can a brand become a sponsor?", a: "Reach out through the Partners page or contact form. Sponsorship options include title/presenting partnerships, brand activation and event partnerships." },
    { q: "Can our town or village host a RUNSAFARI?", a: "Yes — destination development is at the heart of what we do. Write to us with details about your destination and our team will evaluate the opportunity." },
  ]},
];

export default function Faq() {
  const [open, setOpen] = useState("0-0");
  return (
    <div data-testid="faq-page">
      <PageHero eyebrow="HELP CENTRE" title="Frequently Asked Questions"
        subtitle="Everything about registrations, RUNSAFARI events, results, certificates and partnerships." />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
        {FAQ_GROUPS.map((g, gi) => (
          <div key={g.group} className="mb-12">
            <p className="eyebrow">{g.group}</p>
            <div className="mt-5 space-y-3">
              {g.items.map((f, i) => {
                const key = `${gi}-${i}`;
                return (
                  <div key={key} className="card-k overflow-hidden">
                    <button data-testid={`faq-page-item-${key}`} onClick={() => setOpen(open === key ? "" : key)} className="flex w-full items-center justify-between gap-4 px-6 py-4 text-left text-sm font-semibold text-white">
                      {f.q}
                      <ChevronDown size={16} className={`shrink-0 text-brand-cyan transition-transform ${open === key ? "rotate-180" : ""}`} />
                    </button>
                    {open === key && <p className="px-6 pb-5 text-sm leading-relaxed text-slate-400">{f.a}</p>}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
        <div className="card-k mt-4 p-7 text-center">
          <p className="font-display text-2xl font-bold text-white">Still have a question?</p>
          <p className="mt-2 text-sm text-slate-400">Our team responds within one working day.</p>
          <Link to="/contact" data-testid="faq-contact-cta" className="btn-kinetic btn-primary-k mt-6">CONTACT US</Link>
        </div>
      </section>
    </div>
  );
}
